import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { TabId, WellId } from 'common/types'

type CorrelationSchemeTabListOfWells = {
  id: TabId
  wellsIdsList: WellId[]
}

export const correlationSchemeWellsIdsAdapter =
  createEntityAdapter<CorrelationSchemeTabListOfWells>({
    selectId: correlationSchemeTabsList => correlationSchemeTabsList.id,
  })

const initialState = correlationSchemeWellsIdsAdapter.getInitialState()

export const correlationSchemeWellsIdsSlice = createSlice({
  name: 'correlationSchemeWellsIds',
  initialState,
  reducers: {
    addCorrelationSchemeWellsIds(state, action: PayloadAction<CorrelationSchemeTabListOfWells>) {
      correlationSchemeWellsIdsAdapter.upsertOne(state, action.payload)
    },
  },
})

export default correlationSchemeWellsIdsSlice.reducer
